const initialState = {
   data: {},
   isFetching: true,
   pointCustomDomain: {},
   domain_has_completed: true,
};

export default initialState;
